import { FormInstance } from "antd";
import { SelectList } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { LoginResponseModel } from "features/login/data/model/responseModel/LoginResponseModel";
import { productCache } from "utils/cache/productCache";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { UserRoleEnum } from "utils/enums/UserRoleEnum";

type PartnerWithStore = BaseFilterListResponseModel & {
  storeCode?: string;
  storeName?: string;
};

type LsgdPartnerState = {
  selectedPartnerCode?: string;
  selectedPartnerType: number;
  selectedProviderCode?: string;
  isStore: boolean;
  storeOptions: SelectList[];
  staffOptions: SelectList[];
  userOptions: SelectList[];
};

type LoadStoreParams = {
  providerCode?: string;
  partnerCode: string;
};

type LoadStaffParams = LoadStoreParams & {
  storeCode: string;
};

export type SyncLsgdPartnerRoleFiltersParams = {
  user?: LoginResponseModel;
  form?: FormInstance;
  allLabel: string;
  setState: (state: Partial<LsgdPartnerState>) => void;
  loadStores: (params: LoadStoreParams) => void;
  loadStaff?: (params: LoadStaffParams) => void;
  beforeSync?: (partner: PartnerWithStore) => void;
};

export const isLsgdChainOrStoreUser = (user?: LoginResponseModel) =>
  [UserRoleEnum.partnerChain, UserRoleEnum.partnerStore]?.includes(
    user?.role?.code as UserRoleEnum,
  );

export const getPartnerOfUserFromCache = (): PartnerWithStore[] =>
  productCache?.getCache(CacheKeyEnum.partnerOfUser) || [];

export const syncLsgdPartnerRoleFilters = ({
  user,
  form,
  allLabel,
  setState,
  loadStores,
  loadStaff,
  beforeSync,
}: SyncLsgdPartnerRoleFiltersParams) => {
  const partner = getPartnerOfUserFromCache()?.[0];
  if (!isLsgdChainOrStoreUser(user) || !partner?.code) return;

  const storeCode = partner?.store_code || partner?.storeCode;
  const storeName = partner?.store_name || partner?.storeName || storeCode;

  form?.setFieldValue("partnerCode", partner.code);
  if (storeCode) {
    form?.setFieldValue("storeCode", storeCode);
  }

  setState({
    selectedPartnerCode: partner.code,
    selectedPartnerType: 1,
    selectedProviderCode: partner.providerCode || "",
    isStore: true,
    storeOptions: storeCode
      ? [
          { label: allLabel, value: "" },
          { label: storeName, value: storeCode },
        ]
      : [{ label: allLabel, value: "" }],
    staffOptions: [{ label: allLabel, value: "" }],
    userOptions: [{ label: allLabel, value: "" }],
  });

  beforeSync?.(partner);

  loadStores({
    providerCode: partner.providerCode,
    partnerCode: partner.code,
  });

  if (storeCode && loadStaff) {
    loadStaff({
      providerCode: partner.providerCode,
      partnerCode: partner.code,
      storeCode,
    });
  }
};
